import React from 'react';
import Button from '../../../../shared/components/Button/Button';
import DataGrid from '../../../../shared/components/DataGrid/DataGrid';
import Select from '../../../../shared/components/Select/Select';
import StatCard from '../../../../shared/components/StatCard/StatCard';
import Typography from '../../../../shared/components/Typography/Typography';
import { FolderIcon } from './WikiIcons';

function WikiAdminPage({
  adminFilters,
  adminSection,
  articleColumns,
  articles,
  filteredRows,
  mostViewedArticle,
  navigate,
  onFilterChange,
  onPaginationModelChange,
  onResetFilters,
  ownerOptions,
  paginationModel,
  renderWorkflowActions,
  statuses = [],
  wikiArticleTypes,
  wikiCategories,
}) {
  const publishedCount = articles.filter((article) => article.status === 'Publie').length;
  const draftCount = articles.filter((article) => article.status === 'Brouillon').length;
  const validationCount = articles.filter((article) => article.status === 'A valider').length;
  const reviewCount = articles.filter((article) => article.status === 'A reviser').length;
  const adminColumns = [
    ...articleColumns.map((column) => (
      column.field === 'title'
        ? {
          ...column,
          renderCell: (params) => (
            <Button
              className="wiki-admin-title-action"
              size="small"
              variant="ghost"
              onClick={(event) => {
                event.stopPropagation();
                navigate(`/Wiki/article/${params.row.slug || params.row.id}`);
              }}
            >
              {params.row.title}
            </Button>
          ),
        }
        : column
    )),
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1.2,
      minWidth: 240,
      renderCell: (params) => renderWorkflowActions(params.row),
    },
  ];

  return (
    <div className="wiki-content-stack">
      <div className="wiki-section-header">
        <Typography variant="h4">Administration du Wiki - {adminSection.label}</Typography>
        <div className="wiki-editor-actions">
          <Button variant="secondary" iconStart={<FolderIcon fontSize="small" />} onClick={() => navigate('/Wiki/admin/categories')}>
            Categories
          </Button>
          <Button variant="primary" onClick={() => navigate('/Wiki/new')}>
            Nouvel article
          </Button>
        </div>
      </div>
      <div className="wiki-admin-stats">
        <StatCard label="Articles publies" value={publishedCount} variant="success" />
        <StatCard label="Brouillons" value={draftCount} />
        <StatCard label="A valider" value={validationCount} variant="warning" />
        <StatCard label="A reviser" value={reviewCount} variant="danger" />
        <StatCard
          label="Article le plus consulte"
          value={mostViewedArticle ? mostViewedArticle.views : 0}
          helper={mostViewedArticle ? mostViewedArticle.title : 'Aucune consultation'}
          variant="info"
        />
      </div>
      <div className="wiki-admin-filters">
        <Select
          fullWidth
          label="Categorie"
          placeholder="Toutes"
          value={adminFilters.category}
          onChange={(event) => onFilterChange('category', event.target.value)}
          options={wikiCategories.map((category) => ({ value: category.slug, label: category.name }))}
        />
        <Select
          fullWidth
          label="Type"
          placeholder="Tous"
          value={adminFilters.type}
          onChange={(event) => onFilterChange('type', event.target.value)}
          options={wikiArticleTypes.map((type) => ({ value: type.name, label: type.name }))}
        />
        <Select
          fullWidth
          label="Referent"
          placeholder="Tous"
          value={adminFilters.owner}
          onChange={(event) => onFilterChange('owner', event.target.value)}
          options={ownerOptions.map((owner) => ({ value: owner, label: owner }))}
        />
        <Select
          disabled={Boolean(adminSection.status)}
          fullWidth
          helperText={adminSection.status ? `Vue limitee au statut ${adminSection.status}` : ''}
          label="Statut"
          placeholder="Tous"
          value={adminSection.status || adminFilters.status}
          onChange={(event) => onFilterChange('status', event.target.value)}
          options={statuses.map((status) => ({ value: status, label: status }))}
        />
        <Button variant="tertiary" onClick={onResetFilters}>
          Reinitialiser
        </Button>
      </div>
      <DataGrid
        rows={filteredRows}
        columns={adminColumns}
        getRowId={(row) => row.id}
        pageSizeOptions={[5, 10, 25]}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
      />
    </div>
  );
}

export default WikiAdminPage;
